module.exports = __webpack_public_path__ + "img/grid-3x3.f1726ac9.svg";